import { FC, useCallback } from "react"
import { Button, ButtonProps, LinkBaseProps } from "@mui/material"
import { isFunction } from "lodash"

import { ShareIcon } from "components/icons"
import { useTranslation } from "providers/i18n"

interface IShareButtonProps extends ButtonProps, Pick<LinkBaseProps, "target"> {
  title?: string
  text?: string
  url?: string
  label?: string
}

export const ShareButton: FC<IShareButtonProps> = ({
  title,
  text,
  url,
  label = "Share",
  onClick,
  ...props
}) => {
  const { t } = useTranslation()
  const isSharebale = !!navigator.share
  const handleClick = useCallback(
    async (event) => {
      if (isFunction(onClick)) onClick(event)

      if (isSharebale) {
        try {
          await navigator.share({ title, text, url })
          alert("Share successfull")
        } catch (err) {
          console.log("Error: ", err)
        }
      } else {
        console.log("Native Web Sharing not supported")
      }
    },
    [onClick, text, title, url, isSharebale]
  )

  return (
    isSharebale && (
      <Button
        variant="outlined"
        target="_top"
        rel="noopener noreferrer"
        startIcon={<ShareIcon />}
        onClick={handleClick}
        {...props}
      >
        {t(label)}
      </Button>
    )
  )
}
